export const tr_available = {
	DE: 'Verfügbar',
	EN: 'Available',
};
export const tr_unavailable = {
	DE: 'Nicht verfügbar',
	EN: 'Unavailable',
};

export const trTotal = {
	DE: 'Total',
};
export const trReserved = {
	DE: 'Reserviert',
	EN: 'Reserved',
};
export const trNewGoods = {
	DE: 'Neu',
	EN: 'New',
};
export const trProofGoods = {
	DE: 'Prüfen',
	EN: 'Proof',
};
export const trDefectGoods = {
	DE: 'Defekt',
	EN: 'Defect',
};
export const trStockEdit = {
	DE: 'Lager ${NAME} bearbeiten',
	EN: 'Edit stock ${NAME}',
};
export const trStockAdd = {
	DE: 'Lager hinzufügen',
	EN: 'Add stock',
};
export const trCreate = {
	DE: 'Anlegen',
	EN: 'Create',
};

export const tr_reorder_level = {
	EN: 'Reorder Level',
	DE: 'Nachbestellschwelle',
};

export const tr_current_need = {
	EN: 'Current Need',
	DE: 'Aktueller Bedarf',
};

export const tr_purchase_pu = {
	DE: 'VPE Einkauf',
	EN: 'Purchase PU',
};

export const tr_current_supplier = {
	DE: 'Aktiver Lieferant',
	EN: 'Current supplier',
};
export const trPriceDescending = {
	EN: 'Price, descending',
	DE: 'Preis: absteigend',
	FR: 'Prix : décroissant',
};
export const trPriceAscending = {
	DE: 'Preis: aufsteigend',
	EN: 'Price, ascending',
	FR: 'Prix : croissant',
};

export const trSKUDescending = {
	EN: 'SKU, descending',
	DE: 'SKU: absteigend',
	FR: 'SKU : décroissant',
};
export const trSKUAscending = {
	DE: 'SKU: aufsteigend',
	EN: 'SKU, ascending',
	FR: 'SKU : croissant',
};

export const trStockDescending = {
	EN: 'Stock, descending',
	DE: 'Lager: absteigend',
	FR: 'Stock : décroissant',
};
export const trStockAscending = {
	DE: 'Lager aufsteigend',
	EN: 'Stock, ascending',
	FR: 'Stock : croissant',
};
export const trEmptyResult = {
	DE: 'Leider ergab Ihre Suche keine Treffer.',
	EN: 'Unfortunately, your search did not yield any results.',
	// prettier-ignore
	FR: 'Malheureusement, votre recherche n\'a donné aucun résultat.',
};

export const trDeleteImportTask = {
	EN: 'Delete import task',
	DE: 'Import Task löschen',
};

export const trRetryImportTask = {
	EN: 'Retry import task',
	DE: 'Import Task erneut ausführen',
};

export const trDeleteImportTaskWithPartNumber = {
	EN: 'Do you really want to delete import task ${uid} ?',
	DE: 'Möchten Sie wirklich den import task ${uid} löschen ?',
};

export const trRetryImportTaskWithPartNumber = {
	EN: 'Do you really want to retry import task ${uid} ?',
	DE: 'Möchten Sie wirklich den import task ${uid} erneut ausführen ?',
};

export const trPromotion = {
	ALL: 'Promotion',
};

export const trEslPage = {
	ALL: 'Esl Page',
};
export const trPromotions = {
	ALL: 'Promotions',
};

export const trStartDate = {
	DE: 'Startdatum',
	EN: 'Start date',
};

export const trEndDate = {
	DE: 'Enddatum',
	EN: 'End date',
};
export const trOnlyGoodsInStock = {
	DE: 'Nur vorrätige Ware',
	EN: 'Only goods in stock',
	FR: 'Biens en stock',
};
export const tr_release = {
	DE: 'Erscheinung',
	EN: 'Release',
};
export const tr_presale = {
	DE: 'Vorverkauf',
	EN: 'Presale',
};
export const trAssignNewGlobalGtin = {
	de: 'Neue globale Gtin vergeben',
	en: 'Assign new global gtin',
};
export const trAssignLocalGtin = {
	de: 'Lokale Gtin zuweisen',
	en: 'Assign local gtin',
};
export const trThisProcessCannotBeReversed = {
	de: 'Nach dem Speichern kann dieser Prozess nicht rückgängig gemacht werden',
	en: 'After saving, this process cannot be undone!',
};
export const trInThisprocessAGlobalGtinIsConsumedAndCannotBeUsedAgain = {
	de: 'In diesem Prozess wird eine globale Gtin verbraucht und kann nicht noch einmal benutzt werden. ',
	en: 'In this process, a global gtin is consumed and cannot be used again.',
};
